<template>
  <rest-list-page :page-title="pageTitle" :fetch-endpoint="fetchEndpoint">
    <template slot="actions">
      <router-link :to="createRoute" v-if="!readonly">
        <el-button type="primary" icon="el-icon-plus">
          {{ $t('Metrics_MetricList_Create') }}
        </el-button>
      </router-link>
    </template>

    <template slot="table">
      <rest-list-column
        prop="title"
        :title="$t('Metrics_Field_Title')"
        :filterable="true"
      ></rest-list-column>

      <rest-list-column
        prop="name"
        :title="$t('Metrics_Field_Name')"
        :filterable="true"
      ></rest-list-column>

      <rest-list-column
        prop="unit"
        :title="$t('Metrics_Field_Unit')"
        :filterable="true"
      ></rest-list-column>

      <rest-list-column-actions v-if="readonly">
        <template slot-scope="scope">
          <rest-list-action-view :route="rowViewRoute(scope.row)" />
        </template>
      </rest-list-column-actions>

      <rest-list-column-actions v-else>
        <template slot-scope="scope">
          <rest-list-action-update :route="rowUpdateRoute(scope.row)" />
          <rest-list-action-delete
            :endpoint="rowDeleteEndpoint(scope.row)"
            :name="scope.row.title"
          />
        </template>
      </rest-list-column-actions>
    </template>
  </rest-list-page>
</template>

<script>
import RestListPage from '@/common/components/rest/RestListPage'
import RestListColumn from '@/common/components/rest/RestListColumn'
import RestListColumnActions from '@/common/components/rest/RestListColumnActions'
import RestListActionUpdate from '@/common/components/rest/RestListActionUpdate'
import RestListActionView from '@/common/components/rest/RestListActionView'
import RestListActionDelete from '@/common/components/rest/RestListActionDelete'
import { projectEndpoint, projectRoute } from '@/core/helpers'

export default {
  name: 'MetricListPage',

  components: {
    RestListPage,
    RestListColumn,
    RestListColumnActions,
    RestListActionDelete,
    RestListActionUpdate,
    RestListActionView
  },

  computed: {
    pageTitle() {
      return this.$t(this.$route.meta.title)
    },

    fetchEndpoint() {
      return projectEndpoint({
        method: 'get',
        url: `metrics`,
        params: {}
      })
    },

    createRoute() {
      return projectRoute({
        name: 'MetricCreate'
      })
    },

    readonly() {
      return !this.$can('manageProjectTechnical')
    }
  },

  methods: {
    rowViewRoute(row) {
      return projectRoute({
        name: 'MetricView',
        query: { id: row.id }
      })
    },

    rowUpdateRoute(row) {
      return projectRoute({
        name: 'MetricUpdate',
        query: { id: row.id }
      })
    },

    rowDeleteEndpoint(row) {
      return projectEndpoint({
        method: 'delete',
        url: `metrics/${row.id}`
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/metrics/pages/MetricListPage.vue